import { render, staticRenderFns } from "./liveMatchesTwoPlayer.vue?vue&type=template&id=c223d0f8&scoped=true"
import script from "./liveMatchesTwoPlayer.vue?vue&type=script&lang=js"
export * from "./liveMatchesTwoPlayer.vue?vue&type=script&lang=js"
import style0 from "./liveMatchesTwoPlayer.vue?vue&type=style&index=0&id=c223d0f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c223d0f8",
  null
  
)

export default component.exports